import axios from 'axios';
import queryString from 'query-string';

const server_url = process.env.REACT_APP_SERVER_URL;

const createCatalogueCart = async (token, newData) => {
  return await axios.post(
    `${server_url}/api/catalogue/customer/createCatalogueCart`,
    newData,
    {
      headers: { authorization: `Bearer ${token}` }
    }
  );
};

const getCatalogueCart = async (token, params) => {
  const query = queryString.stringify(params);
  return await axios.get(
    `${server_url}/api/catalogue/customer/getCatalogueCart?${query}`,
    {
      headers: { authorization: `Bearer ${token}` }
    }
  );
};

const updateCatalogueCart = async (token, newData) => {
  return await axios.post(
    `${server_url}/api/catalogue/customer/updateCatalogueCart`,
    newData,
    {
      headers: { authorization: `Bearer ${token}` }
    }
  );
};

export { createCatalogueCart, getCatalogueCart, updateCatalogueCart };
